import { createSelector } from '@reduxjs/toolkit';

import { IGlobalState } from 'app/models';

export const isRunning = createSelector(
  ({ app }: IGlobalState) => app?.running,
  (_: IGlobalState, key: string) => key,
  (processes, key) => !!processes?.includes(key),
);
